import { getAboutPage } from "../../../config/aboutContent.js";
import { buildAnimatedHeading } from "../../HeroTitleAnimation.js";
import { buildSectionPillRow } from "../../components/SectionPill.js";

export function createAboutMissionSection() {
  const { mission } = getAboutPage();
  const section = document.createElement("section");
  section.id = "mission";
  section.className = "section about-mission";

  section.innerHTML = `
    <div class="section__inner">
      <div class="about-mission__intro reveal">
        ${buildSectionPillRow(mission.badge)}
        <h2 class="about-mission__title">${buildAnimatedHeading(mission.titleSegments)}</h2>
      </div>
      <div class="about-mission__grid">
        ${mission.cards
          .map(
            (card, i) => `
          <article class="about-mission__card reveal" style="--delay: ${0.1 * (i + 1)}s; --card-i: ${i}">
            <span class="about-mission__eyebrow">${card.eyebrow}</span>
            <h3>${card.title}</h3>
            <p>${card.body}</p>
          </article>
        `
          )
          .join("")}
      </div>
    </div>
  `;

  return section;
}
